import {
  List,
  Datagrid,
  NumberField,
  FunctionField,
  TextInput,
} from "react-admin";
import { StatusChip } from "../../../../components/StatusChip";
import { CopyableField, DateTimeField } from "../../../../shared/fields";

const filters = [
  <TextInput key="roundId" source="roundId" label="Round ID" alwaysOn />,
];

export const RoundList = () => (
  <List
    filters={filters}
    sort={{ field: "startedAt", order: "DESC" }}
    perPage={25}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <CopyableField source="roundId" label="Round ID" sortable={false} />
      <FunctionField
        label="State"
        render={(r: { state?: string }) => <StatusChip value={r?.state} />}
      />
      <NumberField
        source="crashPoint"
        label="Crash Point"
        options={{ minimumFractionDigits: 2 }}
      />
      <DateTimeField source="initializedAt" label="Initialized" />
      <DateTimeField source="startedAt" label="Started" />
      <DateTimeField source="crashedAt" label="Crashed" />
    </Datagrid>
  </List>
);
